
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("a4qOe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9NDUe = parcelRequire("9NDUe");

var $1ANj0 = parcelRequire("1ANj0");

var $2mIUd = parcelRequire("2mIUd");


var $eSuZj = parcelRequire("eSuZj");


var $9eE57 = parcelRequire("9eE57");


var $1xpoY = parcelRequire("1xpoY");

function $3103a851b1e5f9ca$export$464646248fa80ca7() {
    return function allowlist(key) {
        /**
		 * Key formats:
		 *
		 * product  -> {publisher.product}.fe.{experience:type}.{experience:id}
		 *
		 * platform -> platform.fe.{experience:type}.{platform.component}.{experience.id}
		 */ const keyParts = key.split('.');
        const publisher = keyParts[0];
        function platformAllowlist(component, experience) {
            /**
			 * UFO for Smart Experiences team components
			 * @returns {boolean}
			 */ function isASmartComponentExperience() {
                return [
                    'smart-user-picker',
                    'user-picker',
                    'mention'
                ].includes(component) && [
                    'smart-user-picker-rendered',
                    'user-picker-rendered',
                    'smart-user-picker-options-shown',
                    'user-picker-options-shown'
                ].includes(experience);
            }
            /**
			 * Does the platform is a search dialog experience?
			 * @returns {boolean}
			 */ function isSearchDialogExperience() {
                const searchComponentPrefix = 'search-';
                return component.startsWith(searchComponentPrefix);
            }
            /**
			 * Does the platform is a media picker event?
			 * @returns {boolean}
			 */ function isAMediaEvent() {
                const mediaComponentPrefix = 'media-';
                return component.startsWith(mediaComponentPrefix);
            }
            /**
			 * Determine if the UFO event in the allowed list is sourced from reaction component
			 * @returns {boolean}
			 */ function isReactionsExperience() {
                const reactionComponents = [
                    'reactions-picker',
                    'reactions-list',
                    'reaction-item'
                ];
                const reactionExperiences = [
                    'reactions-rendered',
                    'reactions-picker-opened',
                    'reaction-added',
                    'reaction-details-fetched',
                    'reaction-removed'
                ];
                return reactionComponents.includes(component) && reactionExperiences.includes(experience);
            }
            /**
			 * Determine if the UFO event in the allowed list is sourced from emoji component
			 * @returns {boolean}
			 */ function isEmojiEvent() {
                const emojiComponents = [
                    'emoji',
                    'emoji-picker',
                    'emoji-provider'
                ];
                const emojiExperiences = [
                    'emoji-rendered',
                    'emoji-resource-fetched',
                    'emoji-picker-opened',
                    'emoji-searched',
                    'emoji-uploaded',
                    'emoji-selection-recorded'
                ];
                return emojiComponents.includes(component) && emojiExperiences.includes(experience);
            }
            /**
			 * Is it a People experience
			 * @returns {boolean}
			 */ function isPeopleExperience() {
                if (component === 'people') {
                    const allowedPeopleAndTeamsExperiences = [
                        'render-team-member-invite-dialog',
                        'render-team-member-remove-dialog',
                        'remove-member-from-team-action',
                        'add-new-member-to-team-action',
                        'render-people-nav-menu',
                        'team-creation-action',
                        'remove-a-member-from-team',
                        'invite-members-to-team',
                        'render-share-dialog',
                        'share-submit-action',
                        'membership-control-change',
                        'membership-control-change-handle-requests',
                        'membership-control-change-change-team-type',
                        'search-people-and-teams-page-results',
                        'search-people-dropdown-results',
                        'search-teams-dropdown-results',
                        'search-people-and-teams-dropdown-results'
                    ];
                    return allowedPeopleAndTeamsExperiences.includes(experience);
                }
                return false;
            }
            /**
			 * Is it an Invite People experience
			 * @returns {boolean}
			 */ function isInvitePeopleExperience() {
                if (component === 'invite-people') {
                    const allowedInvitePeopleExperiences = [
                        'invite-form-submitted',
                        'invite-people-rendered',
                        'teams-invite-section-experience'
                    ];
                    return allowedInvitePeopleExperiences.includes(experience);
                }
                return false;
            }
            /**
			 * Does the platform is a notification experience?
			 * @returns {boolean}
			 */ function isNotificationListExperience() {
                if (component === 'notificationList') {
                    const allowedExperiences = [
                        'notification-list-render-notifications-without-content',
                        'notification-list-render-notifications-with-content'
                    ];
                    return allowedExperiences.includes(experience);
                }
                return false;
            }
            /**
			 * Determines if the UFO event in the allowed list is sourced from smart link component
			 */ function isASmartLinkExperience() {
                return component === 'smart-links' && [
                    'smart-link-rendered',
                    'smart-link-authenticated',
                    'smart-link-action-invocation',
                    'smart-link-ai-summary'
                ].includes(experience);
            }
            function isLinkPickerExperience() {
                return component === 'link-picker';
            }
            function isDatasourceExperience() {
                return component === 'datasource';
            }
            /**
			 * Is it an Atlassian Switcher experience
			 * @returns {boolean}
			 */ function isAtlassianSwitcherExperience() {
                return component === 'atlassianSwitcher';
            }
            function isPlatformProductExperience() {
                const allowedPlatformComponents = [
                    'ai-speech-to-text',
                    'ai-snippet',
                    'audio-player',
                    'enterprise-her'
                ];
                return allowedPlatformComponents.includes(component);
            }
            function isEditorExperience() {
                return component === 'editor';
            }
            return isASmartComponentExperience() || isEmojiEvent() || isReactionsExperience() || isAMediaEvent() || isSearchDialogExperience() || isNotificationListExperience() || isPeopleExperience() || isASmartLinkExperience() || isLinkPickerExperience() || isInvitePeopleExperience() || isDatasourceExperience() || isAtlassianSwitcherExperience() || isPlatformProductExperience() || isEditorExperience();
        }
        function confluenceAllowlist() {
            // only confluence with defined perf metrics
            return !key.includes('UNKNOWN');
        }
        switch(publisher){
            case 'confluence':
                return confluenceAllowlist();
            case 'platform':
                // platform -> platform.fe.{experience:type}.{platform.component}.{experience.id}
                const [, , , component, experience] = keyParts;
                return platformAllowlist(component, experience);
            default:
                return false;
        }
    };
}
const $3103a851b1e5f9ca$export$ea92d4e542ec02b3 = ()=>({
        getFeatureFlags: ()=>({}),
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        getTimings: ()=>window.__SSR_MEASURES__ || {}
    });
async function $3103a851b1e5f9ca$export$de27182ff8187d6c(sessionData, getAnalyticsWebClientPromise) {
    const isSynthetic = (0, $1xpoY.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false);
    const gasv3 = await getAnalyticsWebClientPromise;
    (0, $1ANj0.payloadPublisher).setup({
        product: 'confluence',
        app: {
            version: {
                web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                ssr: window.__SSR_BUILD__
            },
            framework: {
                name: 'react',
                version: $42omo.version
            }
        },
        region: sessionData.shard || 'unknown',
        tenantType: isSynthetic ? (0, $2mIUd.TenantType).Synthetic : (0, $2mIUd.TenantType).RealUser,
        gasv3: gasv3,
        featureFlags: [],
        featureFlagClient: {
            getValue: ()=>false
        },
        plugins: [],
        ssr: $3103a851b1e5f9ca$export$ea92d4e542ec02b3(),
        performanceConfig: {
            histogram: {
                [(0, $9NDUe.ExperiencePerformanceTypes).PageLoad]: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                },
                [(0, $9NDUe.ExperiencePerformanceTypes).InlineResult]: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                },
                [(0, $9NDUe.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        },
        allowlist: $3103a851b1e5f9ca$export$464646248fa80ca7()
    });
}
module.exports["setup"] = $3103a851b1e5f9ca$export$de27182ff8187d6c;

});


//# sourceMappingURL=initializeUFOPublisher.71b993c1.js.map
